/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/ArticleDate/theme';

export const ArticleDateTheme = theme;
